<template>
  <!-- 充值-->
  <el-dialog
    :lock-scroll="false"
    :close-on-click-modal="false"
    title="充值"
    :visible="dialogFormVisible"
    width="500px"
    @close="onCancleBtn"
  >
    <el-form
      @submit.prevent
      style="width: 100%"
      label-position="right"
      ref="form"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="备注" prop="card">
        <el-input v-model.trim="form.card"></el-input>
      </el-form-item>
      <el-form-item label="金额" prop="money">
        <el-input v-model.trim="form.money"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onConfirmBtn">确 定</el-button>
      <el-button @click="onCancleBtn">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { resRecharge } from "@/api/url";
export default {
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        money: null,
        card: null,
      },
      rules: {
        money: [
          { required: true, message: "请输入金额", trigger: "blur" },
          // {type:"number",message:"请输入数字",trigger:"blur"}
        ],
      },
    };
  },
  methods: {
    onConfirmBtn() {
      const params = { id: this.id, ...this.form };
      this.$postRequest(resRecharge(), params).then((data) => {
        const { status } = data;
        if (status === 200) {
          this.$emit("func", "success");
          this.$message({
            type: "success",
            message: data.message,
          });
        } else {
          this.$message.error(data.message);
        }
      });
    },
    onCancleBtn() {
      this.$refs["form"].resetFields();
      this.$emit("func", "cancle");
    },
  },
};
</script>
<style scoped>
</style>